export const DOCUMENTO_ARRECADACAO_DTO = {
  "numeroRegistro": "7012215095467217",
  "numeroDocumento": "7012215095467217",
  "dataArrecadacao": "2022-05-30T03:00:00.000+00:00",
  "tipoDocumento": {
    "codigo": 4,
    "descricao": "DOCUMENTO DE ARRECADAÇÃO DE RECEITAS FEDERAIS",
    "nomeAbreviado": "DARF"
  },
  "situacaoDocumento": {
    "codigo": 1,
    "descricao": "Original"
  },
  "valorTotal": 24974.01,
  "receita01": {
    "codigo": 211,
    "descricao": "IRPF - Declaração de Ajuste Anual, Declaração de Saída Definitiva do País e Declaração Final de Espólio",
    "nomeEditado": "IRPF - Declaração de ajuste anual, saída do país e espólio",
    "tipo": "P",
    "dataExtincao": null
  },
  "receita02": null,
  "receita03": null,
  "receita01Valor": 24974.01,
  "receita02Valor": null,
  "receita03Valor": null,
  "bancoCodigo": 1,
  "agenciaCodigo": 1098,
  "redeLocalValor": 24974.01,
  "grandePorteValor": 0,
  "sistemaInteresse": {
    "codigo": 1,
    "descricao": "CONTACORPF"
  },
  "uaAtualContribuinte": "08196",
  "ni": "581.397.968-91",
  "dataVencimento": "31/05/2022",
  "processo": null,
  "referencia": null,
  "dataRecepcao": "2022-05-30T03:00:00.000+00:00",
  "periodoApuracao": "2021-12-31T03:00:00.000+00:00",
  "valorRestituicao": 0,
  "indicadorAutorizacaoDebitoCC": null,
  "indicadorMeioColeta": null,
  "protocoloDebitoCC": null,
  "idDepositoCEF": null,
  "valorSaldoPrincipal": null,
  "valorSaldoMulta": null,
  "valorSaldoJuros": null,
  "modalidadeArrecadacao": {
    "codigo": 1,
    "descricao": "GUICHÊ DE CAIXA"
  },
  "procedencia": {
    "codigo": 7,
    "descricao": "AMBIENTE DE PAGAMENTO RFB-EMISSÃO DE DOCUMENTO"
  },
  "segmentoProcedencia": {
    "codigo": 1,
    "descricao": "NENHUM"
  },
  "indicadorAutomacao": {
    "codigo": 2,
    "descricao": "CÓDIGO DE BARRAS"
  },
  "dataLimitePagamento": "2022-05-31T16:41:30.000+00:00",
  "dataRecepcaoEmitido": "2022-05-30T16:41:30.000+00:00",
  "indicadorMeioUtilizadoRecepcao": null,
  "numeroControleRecepcao": "We9XzmYeqEGvaavO6Dvu1ihQY07edh1cDUh",
  "condicaoDocumento": {
    "codigo": 1,
    "descricao": "REGISTRO DE DOCUMENTO PAGO",
    "isSistematicaAntiga": false
  },
  "sistemaGerador": {
    "codigo": 45,
    "descricao": "PROGRAMA GERADOR DO PGD IRPF"
  },
  "uaContribuinteEmissao": 819600,
  "uaClassificacaoReceitaPrincipal": null,
  "indicadorFormaPagamento": {
    "codigo": 1,
    "descricao": "DINHEIRO"
  },
  "dataEmissao": "2022-05-30T16:41:30.000+00:00",
  "indicadorOrigem": 1,
  "valorDJESUNL": 0,
  "valorDJESDNL": 0,
  "valorDJESUTD": 0,
  "valorDJESDTD": 0,
  "valorDJEVTDC": 0,
  "numeroInscricaoTrabalhadorNI": null,
  "numeroDocumentoVinculado": null,
  "numeroInscricaoDAU": null,
  "numeroIdentificacaoImovel": null,
  "numeroCadastroNacionalObras": null,
  "numeroInscricaoTrabalhador": null,
  "cnpjPrestador": null,
  "cpfSegurado": null,
  "edbaSequencial": null,
  "municipioClassificao": null,
  "municipioContribuinteEmissao": {
    "id": 7107,
    "nome": "SÃO PAULO",
    "ufSg": "SP",
    "estado": {
      "id": "SP",
      "nome": "SÃO PAULO",
      "version": null
    },
    "version": null
  },
  "natureza": {
    "codigo": 1,
    "descricao": "PAGAMENTO/DEPÓSITO"
  },
  "desmembramentos": [
    {
      "numeroDocumento": "7012215095467217",
      "sequencialDesmembramento": 1,
      "numeroRegistro": "7012215095467217",
      "periodoApuracao": "2021-12-31",
      "dataVencimento": "2022-05-31",
      "destinacao": {
        "codigo": "1",
        "descricao": "União"
      },
      "valorTotal": 24974.01,
      "sistemaInteresse": {
        "codigo": 1,
        "descricao": "CONTACORPF"
      },
      "referencia": null,
      "identificadorDepositoCEF": null,
      "processo": null,
      "unidadeFederativaSigla": null,
      "uaClassificacaoCodigo": null,
      "valorPrincipal": 24974.01,
      "valorMulta": 0,
      "valorJuros": 0,
      "valorSaldoPrincipal": null,
      "valorSaldoMulta": null,
      "valorSaldoJuros": null,
      "numeroIdentificadorParcelamento": null,
      "uaClassificacaoPGFPGFN": null,
      "indicadorOrigem": 1,
      "ug": null,
      "gestao": null,
      "indicadorOcorrencia": null,
      "numeroInscricaoDAU": null,
      "numeroIdentificacaoImovel": null,
      "numeroCadastroNacionalObras": null,
      "numeroIdentificacaoTrabalhador": null,
      "cnpjPrestador": null,
      "cpfSegurado": null,
      "modalidadeParcelamento": null,
      "municipio": null,
      "municipioClassificacao": null,
      "fracoes": [
        {
          "numeroDocumento": "7012215095467217",
          "sequencialFracao": 1,
          "valor": 24974.01,
          "receita": {
            "receitaCodigo": 211,
            "receitaNome": "IRPF - Declaração de ajuste anual, saída do país e espólio",
            "extensaoReceitaCodigo": null,
            "extensaoReceitaTexto": null
          },
          "tipoFracao": {
            "codigo": 1,
            "descricao": "Principal"
          },
          "valorSaldo": null
        }
      ]
    }
  ],
  "idVersao": "1653937184000",
  "documentoNumerado": true,
  "darfNumerado": true,
  "dje": false,
  "das": false,
  "pago": true,
  "cancelado": false
};